/** Shared stage identity + colors for borrower notifications and activity timeline. */

const STAGE_DEFS = [
  {
    key: "preenquiry",
    match: /pre[\s_-]*enquir/i,
    chip: "bg-slate-100 text-slate-700 border-slate-300",
    soft: "bg-slate-50 text-slate-700 border-slate-200",
    hex: "#64748b",
    hexSoft: "#e2e8f0",
  },
  {
    key: "enquiry",
    match: /^(?!.*pre).*enquir/i,
    chip: "bg-violet-100 text-violet-800 border-violet-300",
    soft: "bg-violet-50 text-violet-800 border-violet-200",
    hex: "#7c3aed",
    hexSoft: "#ddd6fe",
  },
  {
    key: "application",
    match: /application/i,
    chip: "bg-sky-100 text-sky-800 border-sky-300",
    soft: "bg-sky-50 text-sky-800 border-sky-200",
    hex: "#0284c7",
    hexSoft: "#bae6fd",
  },
  {
    key: "approval",
    match: /approval/i,
    chip: "bg-indigo-100 text-indigo-800 border-indigo-300",
    soft: "bg-indigo-50 text-indigo-800 border-indigo-200",
    hex: "#4f46e5",
    hexSoft: "#c7d2fe",
  },
  {
    key: "valuation",
    match: /valuation/i,
    chip: "bg-amber-100 text-amber-900 border-amber-300",
    soft: "bg-amber-50 text-amber-900 border-amber-200",
    hex: "#d97706",
    hexSoft: "#fde68a",
  },
  {
    key: "audit",
    match: /audit/i,
    chip: "bg-cyan-100 text-cyan-900 border-cyan-300",
    soft: "bg-cyan-50 text-cyan-900 border-cyan-200",
    hex: "#0891b2",
    hexSoft: "#a5f3fc",
  },
  {
    key: "legal",
    match: /legal/i,
    chip: "bg-orange-100 text-orange-900 border-orange-300",
    soft: "bg-orange-50 text-orange-900 border-orange-200",
    hex: "#ea580c",
    hexSoft: "#fed7aa",
  },
  {
    key: "completion",
    match: /complet/i,
    chip: "bg-emerald-100 text-emerald-900 border-emerald-300",
    soft: "bg-emerald-50 text-emerald-900 border-emerald-200",
    hex: "#059669",
    hexSoft: "#a7f3d0",
  },
  {
    key: "notprogressing",
    match: /not\s*progress/i,
    chip: "bg-rose-100 text-rose-800 border-rose-300",
    soft: "bg-rose-50 text-rose-800 border-rose-200",
    hex: "#e11d48",
    hexSoft: "#fecdd3",
  },
];

const DEFAULT_STAGE = {
  key: "default",
  chip: "bg-slate-100 text-slate-700 border-slate-300",
  soft: "bg-slate-50 text-slate-700 border-slate-200",
  hex: "#64748b",
  hexSoft: "#e2e8f0",
};

export function resolveStageKey(labelOrKey) {
  const raw = String(labelOrKey || "").trim();
  if (!raw) return DEFAULT_STAGE.key;
  const compact = raw.toLowerCase().replace(/[\s_-]+/g, "");
  if (compact === "preenquiry" || compact === "pre-enquiry") return "preenquiry";
  if (compact === "notprogressing") return "notprogressing";
  for (const def of STAGE_DEFS) {
    if (def.key === compact || def.key === raw.toLowerCase()) return def.key;
    if (def.match.test(raw)) return def.key;
  }
  return DEFAULT_STAGE.key;
}

export function getStagePalette(labelOrKey) {
  const key = resolveStageKey(labelOrKey);
  return STAGE_DEFS.find((d) => d.key === key) || DEFAULT_STAGE;
}

/** Tailwind classes for notification stage chips */
export function getStageChipClasses(labelOrKey) {
  return getStagePalette(labelOrKey).chip;
}

/** Hex colors for activity timeline nodes */
export function getStageTimelineColors(labelOrKey) {
  const p = getStagePalette(labelOrKey);
  return { solid: p.hex, soft: p.hexSoft, key: p.key };
}
